/**
 * Originally from:
 * https://github.com/i18next/react-i18next/blob/a3ca87c32b6fb1f6a6dd5343396eef3c3410a1db/example/app/i18n.js
 * See License in this folder.
 */

import type { i18n as I18n, TFunction } from "i18next";
import { webpackBackend } from "./webpack-backend";
import { LocalStorageDetector } from "./local-storage-language-detector";
import { FormatNumbersAndDates } from "./i18next-formatter";

const detector = new LocalStorageDetector();

// Webpack 5 resolves the CommonJS export, which has no default property.
const i18n: I18n = require("i18next");

i18n
  .use(webpackBackend)
  .use(detector)
  .init({
    fallbackLng: "en-US",

    // have a common namespace used around the full app
    ns: ["common"],
    defaultNS: "common",

    // Don't try to load fallbacks codes for languages (i.e. don't try to load en for en-US)
    load: "currentOnly",

    // Set to `true` to enable logging
    debug: false,

    // Globally configure wait for react-i18next
    react: {
      useSuspense: true,
    },

    interpolation: {
      escapeValue: false, // not needed for react!!,
      format: FormatNumbersAndDates,
    },
  });

export default i18n;
export const t: TFunction = i18n.t.bind(i18n);
